// import { get } from 'lodash';

export default {
  getUsersReport: (state) => state.reports.usersReport,
  getUsersContestReport: (state) => state.reports.usersContestReport,
  getUserProjectsReport: (state) => state.reports.userProjectsReport,
};
